module.exports = __webpack_public_path__ + "static/illustration-ffp@2x-7e65c08e07dce5d753a5cf98184b947f.png";